// extracted by mini-css-extract-plugin
export default {"list":"ListCard_list__z3D3K"};